import { memo } from 'react'
import { AgentMessage, MessageRole } from '@multiplayer-app/ai-agent-types'

interface MessageHeaderProps {
  message: AgentMessage
}

const formatTime = (dateString?: string) => {
  if (!dateString) return ''
  const date = new Date(dateString)
  return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
}

const getRoleLabel = (message: AgentMessage) => {
  if (message.sender?.displayName) return message.sender.displayName
  if (message.sender?.id && message.sender.id !== 'guest') return message.sender.id
  if (message.agentName) return message.agentName

  const isUser = message.role === MessageRole.User
  return isUser ? 'You' : 'Assistant'
}

export const MessageHeader = memo(({ message }: MessageHeaderProps) => {
  const roleLabel = getRoleLabel(message)

  return (
    <div className='mp-agent-message-header'>
      <span className='mp-agent-message-role'>{roleLabel}</span>
      <span className='mp-agent-message-time'>{formatTime(message.createdAt)}</span>
    </div>
  )
})

MessageHeader.displayName = 'MessageHeader'
